// dateUtils.js

/**
 * Converts an ISO date string into a local date-time string.
 *
 * @param {string} dateStr - The ISO date string to format.
 * @returns {string} - A human-readable local date string, or fallback value.
 */
export const formatLocalDate = (dateStr) => {
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleString();
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "unspecified";
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  };
  return new Date(dateStr).toLocaleString(undefined, options);

}